import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading

  useEffect(() => {
    const token = localStorage.getItem("pb_token");
    if (!token) {
      setUser(null);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("pb_token");
        setUser(null);
      });
  }, []);

  const finishAuth = (data) => {
    localStorage.setItem("pb_token", data.token);
    setUser(data.user);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    finishAuth(data);
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    finishAuth(data);
  };

  const acceptInvite = async (token, password, name) => {
    const { data } = await api.post(`/invites/${token}/accept`, { password, name });
    finishAuth(data);
  };

  const logout = () => {
    localStorage.removeItem("pb_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, acceptInvite, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
